export default {
  NewCarOptionAdd: 'New Car Option Add',
  NewCarFeatureAdd: 'New Car Feature Add',
  RemoveCarFeature: 'Remove Car Feature',
  RemoveCarOption: 'Remove Car Option',
  UpdateCarFeature: 'Update Car Feature',
  UpdateCarManage: 'Update Car Manage',
  UpdateCarModel: 'Update Car Model',
  NewCarModelAdd: 'NewCar Model Add',
  NewCarAdd: 'New Car Add',
  UpdateCar: 'Update Car',
  RemoveCar: 'Remove Car',

  Amount: 'Amount',
  AmountWeight: 'Amount Weight',
  AmountCapacity: 'Amount Capacity',
  CarFeature: 'Car Feature',
  CarAbility: 'CarAbility',
  Car: 'Car',
  CarModel: 'Car Model',
  Color: 'Color',
  Character: 'Character',
  Capacity: 'Capacity',
  MachineProduction: 'Machine Production',
  CapacityThreshold: 'Capacity Threshold',
  CarLength: 'Car Length',
  CarHeight: 'Car Height',
  Cars: 'Car',
  Enable: 'Enable',
  Driver: 'Driver',
  driverId: 'Driver Id',
  DriverName: 'DriverName',
  Disable: 'Disable',
  Dimension: 'Dimension',
  DriverIsLaborer: 'Driver Is Laborer',
  Description: 'Description',
  DimensionWidthThreshold: 'Dimension Width Threshold',
  Feature: 'Feature',
  Order: 'Order',
  Unit: 'Unit',
  Slug: 'Slug',
  Size: 'Size',
  SecondCapacity: 'second Capacity',
  SecondCapacityThreshold: 'Second Capacity Threshold',
  Hight: 'Hight',
  HeightThreshold: 'Height Threshold',
  Width: 'Width',
  WidthThreshold: 'width Threshold',
  WeightThreshold: 'Weight Threshold',
  NoThreshold: 'No Threshold',
  Threshold: 'Threshold',
  TypeofCar: 'Type of Car',
  IranNumber: 'iran Number',
  Image: 'Image',
  Length: 'Length',
  LengthThreshold: 'Length Threshold',
  LaborerCount: 'LaborerCount',
  LaborerCountMin: 'LaborerCount Min',
  LaborerCountMax: 'LaborerCount Max',
  LaborerDescription: 'Laborer description',
  LeftNumber: 'Left Number',
  RightNumber: 'Right Number',
  Plate: 'Palet',
  UnitId: 'Unit Id',
  UnitCapacity: 'Unit Capacity',
  UnitDimension: 'Unit Dimension',
  UnitWeight: 'Unit Weight',
  Weight: 'Weight',
  ProductionYear: 'Production Year',
  NavCode: 'Nav Code',
  Brand: 'Car Brand',
  plateNumber1: 'Plate number section 1',
  plateNumber2: 'Plate number section 2',
  plateNumber3: 'Plate number section 3',
  plateNumber4: 'Plate number section 4',
  cars: 'Car',
  brand: 'brand',
  productionYear: 'Production year',
  iranNumber: 'Iran Number',
  rightNumber: 'Right number',
  leftNumber: 'Left number',
  character: 'Character',
  carModel: 'Car model',
  color: 'Color',
  machineProduction: 'Machine production',
  plate: 'Plate',
  navCode: 'Nav code',
  vehicleId: 'Vehicle ID',
  carModelId: 'Car model ID',
  carFeatureId: 'Car Feature ID',
  carLoadId: 'Car Load ID',
  carBrandId: 'Car Brand ID',
  employeeId: 'Employee ID',
  itemGroupId: 'Item group ID',
  itemId: 'Item ID',
  itemFeatureId: 'Item Feature ID',
  loadId: 'Load ID',
  packageId: 'PAckage ID',
  cartonId: 'Carton ID',
  cancelId: 'Cancel ID',
  organizationId: 'Organization ID',
  feedbackId: 'Feedback ID',
  referrerTypeId: 'Referrer type ID',
  userGroupId: 'User group ID',
  userLevelId: 'User level ID',
  departmentId: 'Department ID',
  mediaId: 'Media ID',
  categoryId: 'Category ID',
  subCategoryId: 'Subcategory ID',
  subjectId: 'Subject ID',
  bankId: 'Bank ID',
  bankAccountId: 'Bank account ID',
  policyId: 'Policy ID',
  distanceFactor: 'distance factor',
  inputFactor: 'input factor',
  personalCar: 'personal car',
  otherCars: 'other cars',
  isVip: 'is vip',
  smartCardNumber: 'Smart card number'
}
